module.exports = __webpack_public_path__ + "assets/CertificacaoISO9001.e5a80a3cd2f20e9cf164ee5f3982113e.png";


/*****************
 ** WEBPACK FOOTER
 ** ./public/img/legenda/CertificacaoISO9001.png
 ** module id = 482
 ** module chunks = 0
 **/